export default "__VITE_ASSET__BzAKOxQw__"